import { request } from "src/shared/utils";
import { API, METHODS } from "src/shared/constants";
import { Filter } from "src/shared/interfaces";
import { CompanyFormShape, CompanyFormUpdateShape, UpdateStatusShape } from "src/containers/Company/interface";

export default {
  getCompanies: (payload: Filter) => request(METHODS.GET, API.COMPANY.GET_COMPANIES)({ params: payload }),
  createCompany: (payload: CompanyFormShape) => request(METHODS.POST, API.COMPANY.CREATE_COMPANY)(payload),
  getCompany: (code: string) => request(METHODS.GET, API.COMPANY.GET_COMPANY(code))(),
  updateCompany: (payload: CompanyFormUpdateShape) => {
    const { code, ...restPayload } = payload;
    return request(METHODS.PUT, API.COMPANY.UPDATE_COMPANY(code))(restPayload);
  },
  updateCompanyStatus: (payload: UpdateStatusShape) => {
    const { code, ...restPayload } = payload;
    return request(METHODS.PUT, API.COMPANY.UPDATE_COMPANY_STATUS(code))(restPayload);
  },
};
